export default __webpack_public_path__ + "static/media/joe.d66e6d50.jpg";